import { KeyTypes } from '../utils'
import { BaseAccessor } from './baseAccessor'

export const categoryAccessor = new BaseAccessor(KeyTypes.CATEGORY)
export const subcategoryAccessor = new BaseAccessor(KeyTypes.SUBCATEGORY)
